




















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mod, randRange } from './scripts/MathTool';
import { clearInterval, setInterval } from 'timers';
import { getHHMMSS } from './scripts/TimerTool';
import Slider from './components/Slider.vue';
import { SongBank, SongMetadata } from './scripts/SongBank';

interface MarqueeGroupSet {
  text: string;
  intervalObj: any;
  counter: number;
  initial: boolean;
  keyword: string;
}

@Component({
  components: { Slider }
})
export default class CaravanPlayer extends Vue {
  @Prop({ default: 'footer' }) private type!: string;
  @Prop() private noMarquee!: boolean;
  @Prop({ default: false }) private stateful!: boolean;
  @Prop({ default: '500px' }) private height!: string;
  @Prop({ default: '90%' }) private width!: string;
  @Prop({ default: 'blue' }) private color!: string;
  private songBank = SongBank;
  private timeUpdateListener: any;
  private duration = 0;
  private currentTimeToDisplay = '00:00:00';
  private durationToDisplay = '00:00:00';
  private progressBarWidth = this.playerType === 'static' ? 35 : 55;
  private maxTextLength = 15;
  private searchMode = false;
  private searchQuery = '';
  private statelessGroupSet = {
    audio: new Audio(),
    playButton: 'Play',
    currentSong: 0
  }
  private volumeIcon: NodeRequire = require('@/assets/icons/VolumeHigh.png');
  private colorSet = {
    blue: '#293c50',
    orange: '#d49113',
    green: '#17775f',
    purple: '#2f103d'
  }
  private mqTitle: MarqueeGroupSet = {
    text: '',
    intervalObj: setInterval(() => {/*Does nothing*/}, 100000),
    counter: 0,
    initial: false,
    keyword: 'title'
  };
  private mqArtist: MarqueeGroupSet = {
    text: '',
    intervalObj: setInterval(() => {/*Does nothing*/}, 100000),
    counter: 0,
    initial: false,
    keyword: 'artist'
  };
  private catalogueGroupSet = {
    width: '0px',
    left: '0px',
    bottom: '0px',
    height: '300px'
  };
  private cardHovered = false;
  private catalogue = false;
  private showCatalogue(): void {
    const ref: any = this.$refs.infofield;
    if (!this.catalogue) {
      this.catalogueGroupSet.width = `${ref.clientWidth}px`;
      this.catalogueGroupSet.left = `${ref.offsetLeft}px`;
      this.catalogueGroupSet.bottom = `${ref.offsetHeight + 2}px`;
    }
    this.catalogue = !this.catalogue;
  }
  private hiddenOnSearch(song: SongMetadata): string {
    let check = this.searchQuery.length > 0
                && !song.artist.toLowerCase().match(this.searchQuery.toLowerCase())
                && !song.title.toLowerCase().match(this.searchQuery.toLowerCase());
    return check ? 'hidden' : '';
  }
  get playIcon(): NodeRequire {
    return this.playButton === 'Play' ? require('@/assets/icons/Play.png') :
      require('@/assets/icons/Pause.png');
  }
  get playerType(): string {
    switch (this.type) {
      case 'footer': case 'header':
        return 'static';
      default:
        return 'instance';
    }
  }
  get wrapperStyle(): object {
    return this.playerType === 'instance' ? {
      width: this.width,
      height: this.height,
      display: 'inline-block',
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12)'
    } : {};
  }
  get currentSongTitle(): string {
    const title = this.songBank[this.currentSong].title;
    if (!this.noMarquee && this.type === 'footer' || this.type === 'header') {
      if (title.length >= this.maxTextLength && !this.mqTitle.initial) {
        this.mqTitle.text = title.substr(0, this.maxTextLength);
        this.mqTitle.initial = true;
        return this.mqTitle.text;
      } else if (title.length >= this.maxTextLength && this.mqTitle.initial) {
        return this.mqTitle.text;
      }
    }
    return title;
  }
  get currentSongArtist(): string {
    const artist = this.songBank[this.currentSong].artist;
    if (artist.length >= this.maxTextLength) {
      this.mqArtist.text = artist.substr(0, this.maxTextLength);
      return this.mqArtist.text;
    }
    return artist;
  }
  // State getters
  get audio(): HTMLAudioElement {
    return this.stateful ? this.$store.state.audio : this.statelessGroupSet.audio;
  }
  get playButton(): string { 
    return this.stateful ? this.$store.state.playButton : this.statelessGroupSet.playButton;
  }
  get currentSong(): number {
    this.resetMarquee(this.mqTitle);
    this.resetMarquee(this.mqArtist);
    return this.stateful ? this.$store.state.currentSong : this.statelessGroupSet.currentSong;
  }
  private checkIfHighlight(song: SongMetadata): string {
    if (this.songBank.indexOf(song) === this.currentSong) {
      return 'playing';
    }
    return '';
  }
  private onVolumeButtonClick(): void {
    switch (this.audio.volume) {
      case 0:
        this.volumeIcon = require('@/assets/icons/VolumeLow.png');
        this.audio.volume = 0.5;
        break;
      case 0.5:
        this.volumeIcon = require('@/assets/icons/VolumeHigh.png');
        this.audio.volume = 1;
        break;
      case 1:
        this.volumeIcon = require('@/assets/icons/VolumeMute.png');
        this.audio.volume = 0;
        break;
    }
  }
  private created(): void {
    this.audio.src = this.songBank[0].file;
    this.timeUpdateListener = () => {
      const current = this.audio.currentTime;
      const total = this.audio.duration;
      this.duration = current / total * 100;
      this.currentTimeToDisplay = getHHMMSS(Math.ceil(this.audio.currentTime));
      this.durationToDisplay = getHHMMSS(Math.ceil(this.audio.duration));
      if (current === total) {
        this.nextOrPreviousSong(true);
      }
    };
    this.audio.addEventListener('timeupdate', this.timeUpdateListener);
    this.setMarquee(this.mqTitle, this.mqTitle.keyword);
    this.setMarquee(this.mqArtist, this.mqArtist.keyword);
  }
  private setMarquee(marqueeGroupSet: MarqueeGroupSet, mode: string): void {
    if (this.noMarquee || this.type !== 'footer' && this.type !== 'header') { return; }
    clearInterval(marqueeGroupSet.intervalObj);
    marqueeGroupSet.intervalObj = setInterval(() => {
      let original = '';
      switch (mode) {
        case 'title': original = this.songBank[this.currentSong].title; break;
        case 'artist': original = this.songBank[this.currentSong].artist; break;
      }
      if (original.length <= this.maxTextLength) { return; }
      marqueeGroupSet.text = original.substring(
        marqueeGroupSet.counter, this.maxTextLength + marqueeGroupSet.counter);
      if (marqueeGroupSet.counter === original.length - this.maxTextLength) {
        marqueeGroupSet.counter = 0;
      } else { marqueeGroupSet.counter++; }
    }, 1000);
  }
  private resetMarquee(marqueeGroupSet: MarqueeGroupSet): void {
    if (this.noMarquee) { return; }
    marqueeGroupSet.initial = false;
    marqueeGroupSet.counter = 0;
    marqueeGroupSet.text = '';
    clearInterval(marqueeGroupSet.intervalObj);
    this.setMarquee(marqueeGroupSet, marqueeGroupSet.keyword);
  }
  private onDestroy(): void {
    this.audio.pause();
    this.audio.removeEventListener('timeupdate', this.timeUpdateListener);
    clearInterval(this.mqTitle.intervalObj);
    clearInterval(this.mqArtist.intervalObj);
  }
  private playOrPause(): void {
    if (this.audio.paused) {
      this.audio.play().catch(() => this.audio.pause());
      this.togglePlayPause(false);
    } else {
      this.audio.pause();
      this.togglePlayPause(true);
    }
  }
  private nextOrPreviousSong(increment: boolean): void {
    const song = mod(this.currentSong + (increment ? 1 : -1), this.songBank.length);
    this.changeSongTo(song);
  }
  private shuffle() {
    this.changeSongTo(randRange(0, this.songBank.length));
  }
  private changeSongTo(index: number): void {
    if (this.stateful) {
      this.$store.commit('setCurrentSong', index);
    } else {
      this.statelessGroupSet.currentSong = index;
    }
    this.audio.src = this.songBank[index].file;
    if (!this.audio.paused) { return; }
    if (this.audio.paused) {
      this.audio.play().catch(() => this.audio.pause());
      this.togglePlayPause(false);
    }
  }
  private togglePlayPause(play: boolean) {
    let playPause;
    playPause = play ? 'Play' : 'Pause';
    if (this.stateful) {
      this.$store.commit('setPlayButton', playPause);
    } else {
      this.statelessGroupSet.playButton = playPause
    }
  }
}
